module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.opened),
      expression: "!opened"
    }],
    staticClass: "btn-toggle",
    on: {
      "click": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "filter-box",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "btn-toggle opened",
    on: {
      "click": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "text-center title"
  }, [_vm._v(_vm._s(_vm.t('Filtering')))]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64a807cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterPanel.vue
// module id = 1308
// module chunks = 2